<template>
  <div></div>
</template>

<script>
// import { getUrlkey } from "@/utils/lib/searchtoobj.js";
import { wxRedirectUrl } from "../../../public/config.json";
import { commonNotify, warningNotify } from "../../utils/lib/toast";

export default {
  data () {
    return {
      code: "",
    };
  },
  created () {
    this.reqHandle();
  },
  methods: {
    reqHandle () {
      this.code = this.$route.query.agentcode;
      this.$http.reqTempLogin().then((res) => {
        this.bus.$emit("saveTokenHandle", res, 1)
        this.$http
          .reqPostGetWeixinPromise({
            http_redirct: wxRedirectUrl + `?agentcode=${this.code}`,
          })
          .then((res) => {
            //console.log("虚拟登录授权===>3", res.item.url);
            if (res.item.url) {
              location.href = res.item.url;
            } else {
              warningNotify(res.rtndesc, this);
            }
          })
          .catch((err) => {
            console.log("微信授权出错", err);
            return;
          });
      });
      // console.log(http_redirct);
    },
  },
};
</script>

<style></style>
